module.exports = __webpack_public_path__ + "img/158.5940e98a.jpg";